<template>
  <div class="introducer-report-list">
        <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Introducer Report</span>
        <div style="float:right">
          
        </div>
      </div>

      <el-form :inline="true" size="medium">

        <el-form-item label="Search Date">
          <el-date-picker
            v-model="dateSearch"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="getIntroducer()">Query</el-button>
          <el-button icon="el-icon-download" type="success" @click="ExcelReport()">Excel</el-button>
          <el-button icon="el-icon-download" type="danger" @click="PDFReport()">PDF</el-button>
        </el-form-item>
      </el-form>
      <div class="table-area" v-loading="loading">
        <data-tables 
          v-if="dataTable.length > 0"
            :data="dataTable" 
            border 
            :page-size="20"
            :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
            <el-table-column prop="customer_code" label="Introducer Code" header-align="center" align="center" width="150"> </el-table-column>
            <el-table-column prop="customer_name" label="Customer Name" header-align="center" align="center"> </el-table-column>
            <el-table-column prop="project_name" label="Project Name" header-align="center" align="center"> </el-table-column>
            <el-table-column prop="customer_status" label="Status" header-align="center" align="center" width="150"> </el-table-column>
            <el-table-column prop="introducer_status" label="State" header-align="center" align="center" width="70"> 
              <template slot-scope="scope">
                <el-tag size="mini" effect="dark" :type="
                            scope.row.introducer_status === 'ON' ? 'success' : 'info'
                          ">{{ scope.row.introducer_status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="number_of_customer" label="Customer" header-align="center" align="center" width="120"> </el-table-column>
            <el-table-column prop="totalgbp" label="Total GBP" header-align="center" align="center" width="120"> </el-table-column>
            <el-table-column prop="totaleur" label="Total EUR" header-align="center" align="center" width="120"> </el-table-column>
          
          </data-tables>
        </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getIntroducerByProject, reportIntroducerExcel, reportIntroducerPDF } from '@/api/introducer'
import { currentDateTime, dateFormat } from '@/utils'
export default {
  props:{
    project: String
  },
  computed: {
    ...mapGetters(["user_project", "company_uid"]),
   
  },
  watch: {
      project(val, old) {
        this.project_uid = val;
        this.getIntroducer();
      }
  },
  data(){
    return{
      loading: false,
      project_uid: this.project,
      dateSearch: "",
      dataTable:[],
      query:{
        from: "",
        to: ""
      }
    }
  },
  methods:{
    getIntroducer(){
      this.loading = true;
       
      this.SelectDate();
      getIntroducerByProject(this.project_uid, this.query).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataTable = data;
        }
      })
    },
    ExcelReport(){
      reportIntroducerExcel(this.project_uid, this.query)
    },
    PDFReport(){
      reportIntroducerPDF(this.project_uid, this.query)
    },
    SelectDate(){
      this.query.from = this.dateSearch[0] || currentDateTime("YYYY-MM-DD")
      this.query.to = this.dateSearch[1] || currentDateTime("YYYY-MM-DD")
    }
  },
  mounted(){
    this.project_uid = this.project || this.user_project;
    this.getIntroducer()
  }

}
</script>

<style lang="scss">
.introducer-report-list{
  .table-area{
    min-height: 200px;
  }
}
</style>